const getBackendErrorMessage = (err: unknown): string | undefined => {
  if (!err || typeof err !== 'object') {
    return undefined;
  }
  const e = err as { response?: { data?: { message?: unknown } }; status?: unknown; message?: unknown };
  // use-submit-doc wraps a client-side upload timeout as { status: 408, message } — the backend
  // never spoke, so it is not a backend message. Callers classify a message-less error as
  // network_error, which turns on hasBadConnectivity so the retry downshifts its budget.
  if (e.status === 408) {
    return undefined;
  }
  if (typeof e.response?.data?.message === 'string') {
    return e.response.data.message;
  }
  if (e.status != null && typeof e.message === 'string') {
    return e.message;
  }
  return undefined;
};

export default getBackendErrorMessage;
